import React from "react";
import { Stack, CardActions, Grid, Box } from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import {
  CardBody,
  CardData,
  CardImage,
  CtaButton,
  Domain,
  InternshipName,
  Tag,
  Title,
} from "./internships.components";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { internshipLink } from "../../common/routes";

function Internships({ title, internshipsData, colorBackground }) {
  return (
    <OuterWrapper
      sx={{ pt: "100px", backgroundColor: colorBackground || "#F8FBFE" }}
    >
      <InnerWrapper>
        <Title px={{ xs: 1.5, md: 0 }}>{title}</Title>
        <Grid container px={{ xs: 1.5, md: 0 }}>
          {internshipsData.map((data) => {
            return (
              <CardBody
                item
                sx={{
                  maxWidth: { sm: 350, md: 400 },
                  ml: { sm: 3, md: 3.8 },
                  mb: { xs: 8, md: 12.5 },
                }}
              >
                <Box sx={{ width: 400, height: 225 }}>
                  <CardImage component="img" image={data.imgUrl} alt="" />
                </Box>
                <CardData>
                  <Domain>{data.domain}</Domain>
                  <InternshipName>{data.name}</InternshipName>
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1.25}
                  >
                    {data.tags.map((tag) => {
                      return <Tag>{tag}</Tag>;
                    })}
                  </Stack>
                </CardData>
                <CardActions
                  sx={{ justifyContent: "space-between", px: 3.5, py: 1.5 }}
                >
                  <CtaButton
                    component={Link}
                    to={`${internshipLink}/${data.internshipID}`}
                  >
                    View this internship
                  </CtaButton>
                  <CtaButton
                    component={Link}
                    to={`${internshipLink}/${data.internshipID}`}
                  >
                    <ArrowForwardIcon />
                  </CtaButton>
                </CardActions>
              </CardBody>
            );
          })}
        </Grid>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default Internships;
